import React, { useState } from 'react';
import "./Navbar.css";
import logo from '../../assets/logo.png';
import contactImg from '../../assets/contact.png'
import {Link} from 'react-scroll';
import menu from '../../assets/menu.png';

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  return (
      <nav className="navbar">
      <img src={logo} alt="Logo" className='logo' />
      <div className="desktopMenu">
        <Link activeClass='active' to='intro' spy={true} smooth={true} offset={-80} duration={500} className="desktopMenuListItem">Home</Link>
        <Link activeClass='active' to='skills' spy={true} smooth={true} offset={-80} duration={500} className="desktopMenuListItem">About</Link>
        <Link activeClass='active' to='works' spy={true} smooth={true} offset={-80} duration={500} className="desktopMenuListItem">Skills</Link>
        <Link activeClass='active' to='Projects' spy={true} smooth={true} offset={-80} duration={500} className="desktopMenuListItem">Projects</Link>
        <Link activeClass='active' to='clients' spy={true} smooth={true} offset={-80} duration={500} className="desktopMenuListItem">Experience</Link>
      </div>
    
      <button className="desktopMenubtn" onClick={() => {
        document.getElementById('contact').scrollIntoView({behavior:'smooth'});

      }}>
        <img src={contactImg} alt="contact" className="desktopMenuImg" />Contact me </button>

        <img src={menu} alt="Menu" className='mobMenu' onClick={()=> setShowMenu(!showMenu)}/>
        <div className="navMenu" style={{ display: showMenu? 'flex': 'none'}}>
          <Link activeClass='active' to='intro' spy={true} smooth={true} offset={-80} duration={500} className="listItem" onClick={()=>setShowMenu(false)}>Home</Link>
          <Link activeClass='active' to='skills' spy={true} smooth={true} offset={-80} duration={500} className="listItem" onClick={() => setShowMenu (false)}>About</Link>
          <Link activeClass='active' to='works' spy={true} smooth={true} offset={-80} duration={500} className="listItem" onClick={()=> setShowMenu(false)}>Skills</Link>
          <Link activeClass='active' to='Projects' spy={true} smooth={true} offset={-80} duration={500} className="listItem" onClick={() => setShowMenu (false)}>Projects</Link>
          <Link activeClass='active' to='clients' spy={true} smooth={true} offset={-80} duration={500} className="listItem" onClick={()=> setShowMenu(false)}>Experience</Link>
        </div>
      </nav>
  )
}

export default Navbar
